const applyTable = ($this, $id = null, pageSize = 20, options) => {
    var table = $(($id || "#tableWithSearch"));

    var settings = {
        "sDom": "<t><'row'<p i>>",
        "ordering": false,
        "destroy": true,
        "scrollCollapse": true,
        "oLanguage": {
            "sLengthMenu": "_MENU_ ",
            "sInfo": "Showing <b>_START_ to _END_</b> of _TOTAL_ entries"
        },
        "iDisplayLength": pageSize || 20,
        "drawCallback": function() {
            $('#tableWithSearch_previous', this.api().table().container())
                .on('click', function() {
                    // $this.goPrev();
                    console.log('previous button has bee clicked')
                });
            $('#tableWithSearch_next', this.api().table().container())
                .on('click', function() {
                    console.log('nexxt button has been clicked');
                    if(options.next) {
                        console.log('next was foound')
                        options.next(table);
                    }
                });
            $('.paginate_button:not(#tableWithSearch_next):not(#tableWithSearch_previous)', this.api().table().container())
                .on('click', function(e) {
                    let incrememt = $(e.target).attr('data-dt-idx');
                    // $this.updateCounters(parseInt(incrememt));
                });
        }
    };

    table.dataTable(settings);
    // search box for table
    $("#search-table").keyup(function() {
        table.fnFilter($(this).val());
    });
}

export default applyTable;
